var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResultsImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 148,
    viewBox: "0 0 152 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5918,
    cy: 74,
    r: 74,
    transform: "rotate(180 77.5918 74)",
    fill: "#F1F1F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.07853,
    cy: 101.436,
    r: 6.5,
    transform: "rotate(125.979 9.07853 101.436)",
    fill: "#CCCCCC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.079,
    cy: 136.436,
    r: 6,
    transform: "rotate(125.979 118.079 136.436)",
    fill: "#CCCCCC",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.85,
    cy: 40.8089,
    r: 6,
    transform: "rotate(125.979 142.85 40.8089)",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.833 99.0833H42.1668C40.196 99.0833 38.5835 100.696 38.5835 102.667C38.5835 104.637 40.196 106.25 42.1668 106.25H113.833C115.804 106.25 117.417 104.637 117.417 102.667C117.417 100.696 115.804 99.0833 113.833 99.0833ZM49.3335 95.5H106.667C110.608 95.5 113.798 92.275 113.798 88.3333L113.833 48.9167C113.833 44.975 110.608 41.75 106.667 41.75H49.3335C45.3918 41.75 42.1668 44.975 42.1668 48.9167V88.3333C42.1668 92.275 45.3918 95.5 49.3335 95.5ZM65.781 59.8458C66.8133 58.308 68.1737 57.0181 69.7643 56.069C71.3549 55.1199 73.1361 54.5352 74.9797 54.357C76.8233 54.1788 78.6835 54.4115 80.4264 55.0384C82.1693 55.6653 83.7516 56.6708 85.0593 57.9825C89.2877 62.2108 89.861 68.7325 86.7435 73.6058L92.3335 79.16C93.3727 80.1992 93.3727 81.9192 92.3335 82.9583C91.2943 83.9975 89.5743 83.9975 88.5352 82.9583L82.981 77.4042C77.3552 80.9875 69.5077 79.6975 65.5302 73.4267C62.9143 69.3417 63.0577 63.8592 65.781 59.8458Z",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2082 74.0001C80.1662 74.0001 83.3748 70.7915 83.3748 66.8334C83.3748 62.8754 80.1662 59.6667 76.2082 59.6667C72.2501 59.6667 69.0415 62.8754 69.0415 66.8334C69.0415 70.7915 72.2501 74.0001 76.2082 74.0001Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2504 61.8182L77.0217 68.8828H74.9783L74.7496 61.8182H77.2504ZM75.9975 72.1442C75.6429 72.1442 75.3379 72.0182 75.0827 71.7663C74.8308 71.5144 74.7049 71.2095 74.7049 70.8516C74.7049 70.5002 74.8308 70.2003 75.0827 69.9517C75.3379 69.6998 75.6429 69.5739 75.9975 69.5739C76.3389 69.5739 76.6388 69.6998 76.8974 69.9517C77.1592 70.2003 77.2901 70.5002 77.2901 70.8516C77.2901 71.0902 77.2288 71.3073 77.1062 71.5028C76.9869 71.6984 76.8294 71.8542 76.6339 71.9702C76.4416 72.0862 76.2295 72.1442 75.9975 72.1442Z",
    fill: "#F1F1F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsImage);
export default __webpack_public_path__ + "static/media/no-results-image.9da53768bcf6cef52ae43a8fecc74144.svg";
export { ForwardRef as ReactComponent };